import { Dispatch, SetStateAction } from "react";

type UseSelectedFilesListParams = {
  setSelectedFiles: Dispatch<SetStateAction<File[] | null>>;
};

export function useSelectedFilesList({
  setSelectedFiles,
}: UseSelectedFilesListParams) {
  function removeSingleSelectedFile(index: number) {
    setSelectedFiles((files) =>
      files ? files.filter((_, i) => i !== index) : null,
    );
  }

  return { removeSingleSelectedFile };
}
